<script setup lang="ts"></script>

<template>
  <icon name="lucide:book-a" />
</template>

<style scoped></style>
